import { render, staticRenderFns } from "./RegionAdd.vue?vue&type=template&id=f69efb2a&scoped=true"
import script from "./RegionAdd.vue?vue&type=script&lang=js"
export * from "./RegionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69efb2a",
  null
  
)

export default component.exports